var map = {
	"./AU/20210827/en/DirectMarketing.vue": [
		"da56",
		"chunk-2d2288d4"
	],
	"./AU/20231127/en/DirectMarketing.vue": [
		"0c64",
		"chunk-2d0aed27"
	],
	"./NZ/20231201/en/DirectMarketing.vue": [
		"3106",
		"chunk-2d0b8dda"
	],
	"./US/20210827/en/DirectMarketing.vue": [
		"6eee",
		"chunk-2d0db4c5"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8acf";
module.exports = webpackAsyncContext;